'use strict';

exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/_react-router@3.0.5@react-router/lib/PromiseUtils.js
// module id = 217
// module chunks = 1